import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { EntInfosContainer, IconDiv, EICol, EntHeaderTitle, FormInputAgence } from './Infos.styled'
import fr from 'react-phone-input-2/lang/fr.json'
import { EIFormCol, EIFormContainer } from '../../../containers/Entity/Entity.styled';
import { FormGroup, FormInput, FormInputTextarea, FormLabel, FormSelect, TelInput } from '../../../styles/Common';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import MandatoryMarker from '../../../components/UI/MandatoryMarker';
import { CTooltip } from '../../../components/UI/CTooltip/CTooltip';
import Textarea from '../../../components/UI/Textarea/Textarea';
import { ToggleIcon, ToggleLabel } from '../../../containers/CampaignForm/CampaignForm.styled';
import CancelIcon from '@mui/icons-material/Cancel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { TH, THead, TBody, Table, TD } from '../../../styles/Table.styled';
import { faCircleInfo, faCirclePlus } from '@fortawesome/free-solid-svg-icons'
import InfosHierarchie from '../InfosLevel/InfosLevel'
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import { getNotyfObject } from '../../../shared/utility';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AssureursBailleurModal from '../../AssureursBailleurModal/AssureursBailleurModal'
import Axios from '../../../axios-proas';

function Infos({ entity, setEntity, hasCampagneAssurance, niveau, setNiveau, hierarchical, setHierarchical, handleInputChange, handlePhoneInputChange, cannotBeModified, setOrganismes, organismes, userType }) {
    const theme = useTheme();
    const { t } = useTranslation();
    const notyf = getNotyfObject();
    const [confirmationModalCodesAssureursShow, setConfirmationModalCodesAssureursShow] = useState(false);
    const [assureurs, setAssureurs] = useState([]);

    const getAssureurs = (id) => {
        Axios.get(import.meta.env.VITE_PREFIX_SERVER_API + 'bailleurs/' + id + '/assureurs', {
            params: null,
        }).then(res => {
            var data = res.data?.sort((a, b) => {
                const aIdNull = a.id == null;
                const bIdNull = b.id == null;

                if (aIdNull && !bIdNull) return -1;
                if (!aIdNull && bIdNull) return 1;

                const aCodeNull = a.codeExterne == null;
                const bCodeNull = b.codeExterne == null;

                if (aCodeNull && !bCodeNull) return -1;
                if (!aCodeNull && bCodeNull) return 1;

                return (a.id ?? 0) - (b.id ?? 0);
            });
            setAssureurs(data)

        })
    }

    useEffect(() => {
        if (entity.id) {
            getAssureurs(entity.id)
        }
    }, [entity])

    const confirmeDeleteOrganisme = (index) => {
        if (index == 0) {
            setOrganismes([])

        } else {
            let tempOrganisme = [...organismes]
            tempOrganisme.splice(index, 1)
            setOrganismes(tempOrganisme)
        }
        setShowModalConfirmation(false)
    }


    ////METADATA
    const handleInputChangeMetaData = e => {
        if (userType == "ADMIN_YOUNOV") {
            const key = e.target.name;
            var value = e.target.value;
            const newMetadata = { ...entity.metadata, [key]: value };
            const newEntity = { ...entity, metadata: newMetadata };
            setEntity(newEntity);
        }
    }
    /////ADRESSE
    const handleInputChangeAdresse = e => {
        if (userType == "ADMIN_YOUNOV") {
            const key = e.target.name;
            var value = e.target.value;
            const newAdresse = { ...entity.adresse, [key]: value };
            const newEntity = { ...entity, adresse: newAdresse };
            setEntity(newEntity);
        }
    }

    const optionChangeHandler = (name, value) => {

        setEntity({
            ...entity,
            [name]: Boolean(value)
        })
    }

    const cancelModalAssureurs = () => {
        setConfirmationModalCodesAssureursShow(false)
        getAssureurs(entity.id)
    }  


    const inputChangeHandlerOrganisme = (e, index) => {
        if (userType == "ADMIN_YOUNOV") {
            const key = e?.target.name;
            let value = e.target.value;
            if (key == "code")
                value = parseInt(value, 10);
            setOrganismes((prevState) => {
                let newOrganismes = [...prevState]
                newOrganismes[index] = { ...newOrganismes[index], [key]: value }
                return newOrganismes
            })
        }
    }
    function hasEmptyProperty(obj) {
        for (let key in obj) {
            if (obj.hasOwnProperty(key) && key != "bailleur") {
                if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
                    return true; // Retourne true si une propriété est vide ou null
                }
            }
        }
        return false; // Retourne false si aucune propriété vide ou null n'est trouvée
    }

    const addNewOrganisme = (e) => {
        //console.log(organismes)
        e.preventDefault();
        let p = { libelle: null, code: null, new: true };
        let organismesTemp = [...organismes];
        let hasEmptyElement = organismesTemp.some((item) => hasEmptyProperty(item))
        if (hasEmptyElement) {
            notyf.error("Vous ne pouvez pas ajouter un nouveau élément, Car il exsite un élément qui contient un champ vide ou null");
        } else {
            organismesTemp.push(p);
            setOrganismes(organismesTemp);
        }
    }

    const body = useMemo(() => organismes?.map((org, index) => (
        <TBody key={index}>
            <tr style={{ width: "100%", display: "flex", justifyContent: "space-between" }} >
                <TD style={{ width: "45%" }} >
                    {
                        <FormInputAgence
                            style={{ width: "99%" }}
                            id="libelle"
                            type="text"
                            name="libelle"
                            //err={isLibelle}
                            placeholder="Ex: YNV"
                            value={org?.libelle || ""}
                            onChange={(e) => inputChangeHandlerOrganisme(e, index)} />
                    }

                </TD>
                <TD style={{ width: "45%" }} >
                    {
                        <FormInputAgence
                            style={{ width: "99%" }}
                            id="libelle"
                            type="text"
                            name="code"
                            //err={isLibelle}
                            placeholder="Ex: 123"
                            value={org?.code || ""}
                            onChange={(e) => inputChangeHandlerOrganisme(e, index)} />
                    }

                </TD>

                <TD style={{ width: "12%" }}>

                    {userType == "ADMIN_YOUNOV" && <CancelIcon onClick={(e) => confirmeDeleteOrganisme(index)} style={{ color: "#EE5A5A", cursor: "pointer", fontSize: "20px" }} />}


                </TD>
            </tr>
        </TBody>
    )), [entity, organismes])

    return (
        <>
            {
                userType == "BAILLEUR" && (
                    <div className="alert alert-warning mt-2" role="alert">
                        <ul>
                            Ces informations sont fournies à titre consultatif uniquement. Elles ne peuvent pas être modifiées. Si vous visualisez une information erronée, prenez contact avec votre gestionnaire Younov
                        </ul>
                    </div>
                )
            }
            <EntInfosContainer>
                <EIFormContainer>
                    <EIFormCol>
                        <FormGroup>
                            <FormLabel htmlFor="name">Raison sociale<MandatoryMarker /></FormLabel>
                            <FormInput
                                id="name"
                                type="text"
                                name="raisonSociale"
                                value={entity?.raisonSociale || ""}
                                onChange={handleInputChange}
                            />
                        </FormGroup>
                        {userType == "ADMIN_YOUNOV" &&<>
                        <FormGroup>
                            <FormLabel htmlFor="logo">Logo<MandatoryMarker /></FormLabel>
                            <FormInput
                                id="logo"
                                type="text"
                                name="logo"
                                value={entity?.logo || ""}
                                onChange={handleInputChange}
                            />
                        </FormGroup>

                        <FormGroup>
                            <FormLabel htmlFor="code">Code client Younov<MandatoryMarker /></FormLabel>
                            <FormInput
                                id="code"
                                type="text"
                                name="codeGesCom"
                                value={entity?.codeGesCom || ""}
                                onChange={handleInputChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <FormLabel htmlFor="libelleCourt">Libellé court<MandatoryMarker /></FormLabel>
                            <FormInput
                                id="libelleCourt"
                                type="text"
                                name="libelleCourt"
                                value={entity?.libelleCourt || ""}
                                onChange={!entity?.id && handleInputChange}
                            />
                        </FormGroup>
                        </>}
                        <FormGroup>
                            <FormLabel htmlFor="url">URL télédéclaration<MandatoryMarker /></FormLabel>
                            <FormInput
                                id="url"
                                type="text"
                                name="url"
                                value={entity?.url || ""}
                                onChange={handleInputChange}
                            />
                        </FormGroup>

                        <FormGroup>
                            <FormLabel htmlFor="adresseMail">Adresse courriel<MandatoryMarker /></FormLabel>
                            <FormInput
                                id="adresseMail"
                                type="email"
                                name="adresseMail"
                                value={entity?.adresseMail || ""}
                                onChange={handleInputChange}
                            />
                        </FormGroup>

                       

                        <FormGroup>
                            <FormLabel htmlFor="telephoneSupport">Téléphone du support</FormLabel>
                            <FormInput
                                id="telephoneSupport"
                                type="tel"
                                name="telephoneSupport"
                                pattern="[0-9]{10}"
                                value={entity?.telephoneSupport || ""}
                                onChange={handlePhoneInputChange}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Textarea text={entity?.hotlineMailText} label={"Texte support téléphonique"} name={"hotlineMailText"} maxLength={25} onChange={handleInputChange} />
                        </FormGroup>

                        <FormGroup>
                            <Textarea text={entity?.slsMentionsLegales} label={"Mentions légales SLS"} name={"slsMentionsLegales"} maxLength={25} onChange={handleInputChange} />
                        </FormGroup>

                        <FormGroup>
                            <Textarea text={entity?.slsPenalitesMailText} label={"Pénalités SLS "} name={"slsPenalitesMailText"} maxLength={25} onChange={handleInputChange} />
                        </FormGroup>

                        <FormGroup>
                            <Textarea text={entity?.opsMentionsLegales} label={"Mentions légales OPS"} name={"opsMentionsLegales"} maxLength={25} onChange={handleInputChange} />
                        </FormGroup>

                        <FormGroup>
                            <Textarea text={entity?.opsPenalitesMailText} label={"Pénalités OPS"} name={"opsPenalitesMailText"} maxLength={25} onChange={handleInputChange} />
                        </FormGroup>

                        <FormGroup>
                            <Textarea text={entity?.mentionsCnil} label={"Mentions CNIL"} name={"mentionsCnil"} maxLength={25} onChange={handleInputChange} />
                        </FormGroup>
                        {userType == "ADMIN_YOUNOV" && <>
                            <FormGroup>
                                <FormLabel htmlFor="fax">Fax</FormLabel>
                                <FormInput
                                    id="fax"
                                    type="tel"
                                    name="fax"
                                    pattern="[0-9]{10}"
                                    // placeholder="Contact administrateur"
                                    value={entity?.fax || ""}
                                    onChange={(e) => handlePhoneInputChange(e)}
                                />
                            </FormGroup>
                
                            <FormGroup>
                                <FormLabel active={false}>Saisie enquête interne</FormLabel>
                                <ToggleIcon >
                                    {
                                      +entity?.saisieInterne ?
                                        <ToggleOnIcon
                                            style={{ color: theme.colors.secondary }}
                                            fontSize="large"
                                            onClick={() => optionChangeHandler("saisieInterne", 0)}
                                        /> :
                                        <ToggleOffIcon
                                            style={{ color: theme.colors.younovGray }}
                                            fontSize="large"
                                            onClick={() => optionChangeHandler("saisieInterne", 1)}
                                        />
                                    }
                                </ToggleIcon>
                            </FormGroup>
                            <FormGroup>
                             <FormLabel active={false}>Contrôle enquête interne</FormLabel>
                              <ToggleIcon >
                                {
                                  +entity?.controleInterne ?
                                    <ToggleOnIcon
                                      style={{ color: theme.colors.secondary }}
                                      fontSize="large"
                                      onClick={() => optionChangeHandler("controleInterne", 0)}
                                    /> :
                                    <ToggleOffIcon
                                      style={{ color: theme.colors.younovGray }}
                                      fontSize="large"
                                      onClick={() => optionChangeHandler("controleInterne", 1)}
                                    />
                                }
                              </ToggleIcon>
                            </FormGroup>
                            <FormGroup>
                              <FormLabel active={false}>Gestion d'adresse postale</FormLabel>
                              <ToggleIcon >
                                {
                                  +entity?.estGestionAdresse ?
                                    <ToggleOnIcon
                                      style={{ color: theme.colors.secondary }}
                                      fontSize="large"
                                      onClick={() => optionChangeHandler("estGestionAdresse", 0)}
                                    /> :
                                    <ToggleOffIcon
                                      style={{ color: theme.colors.younovGray }}
                                      fontSize="large"
                                      onClick={() => optionChangeHandler("estGestionAdresse", 1)}
                                    />
                                }
                              </ToggleIcon>
                            </FormGroup>
                        </>
              }
                        {entity.id && hasCampagneAssurance &&
                            <FormGroup>
                                <ToggleLabel active={false} >Référentiel assureur &nbsp;
                                        <CTooltip title={"Visualiser les codes assureurs"} className="tableActions__icon">
                                        </CTooltip>
                                    
                                </ToggleLabel>

                                <ToggleIcon >
                                    <VisibilityIcon onClick={() => setConfirmationModalCodesAssureursShow(true)} />

                                </ToggleIcon>

                            </FormGroup>
                        }

                    </EIFormCol>

                    <EIFormCol>
                        <FormGroup>
                            <FormLabel htmlFor="ligne1">Adresse ligne1<MandatoryMarker /></FormLabel>
                            <FormInput
                                id="ligne1"
                                type="text"
                                name="ligne1"
                                // placeholder="Adresse"
                                value={entity?.adresse?.ligne1 || ""}
                                onChange={handleInputChangeAdresse}
                            />
                        </FormGroup>

                        <FormGroup>
                            <FormLabel htmlFor="ligne2">Adresse ligne2</FormLabel>
                            <FormInput
                                id="ligne2"
                                type="text"
                                name="ligne2"
                                // placeholder="Complément d'adresse"
                                value={entity?.adresse?.ligne2 || ""}
                                onChange={handleInputChangeAdresse}
                            />
                        </FormGroup>

                        <FormGroup>
                            <FormLabel htmlFor="ligne3">Adresse ligne3</FormLabel>
                            <FormInput
                                id="ligne3"
                                type="text"
                                name="ligne3"
                                // placeholder="Complément d'adresse"
                                value={entity?.adresse?.ligne3 || ""}
                                onChange={handleInputChangeAdresse}
                            />
                        </FormGroup>

                        <FormGroup>
                            <FormLabel htmlFor="ligne4">Adresse ligne4</FormLabel>
                            <FormInput
                                id="ligne4"
                                type="text"
                                name="ligne4"
                                // placeholder="Complément d'adresse"
                                value={entity?.adresse?.ligne4 || ""}
                                onChange={handleInputChangeAdresse}
                            />
                        </FormGroup>

                        <FormGroup>
                            <FormLabel htmlFor="codePostal">Code postal<MandatoryMarker /></FormLabel>
                            <FormInput
                                id="codePostal"
                                type="number"
                                name="codePostal"
                                // placeholder="Code postal"
                                value={entity?.adresse?.codePostal || ""}
                                onChange={handleInputChangeAdresse}
                            />
                        </FormGroup>

                        <FormGroup>
                            <FormLabel htmlFor="ville">Ville<MandatoryMarker /></FormLabel>
                            <FormInput
                                id="ville"
                                type="text"
                                name="ville"
                                // placeholder="Ville"
                                value={entity?.adresse?.ville || ""}
                                onChange={handleInputChangeAdresse}
                            />
                        </FormGroup>

                        <FormGroup>
                            <FormLabel htmlFor="countryCode">Pays<MandatoryMarker /></FormLabel>
                            <FormSelect
                                id="countryCode"
                                name="pays"
                                value={entity?.adresse?.pays || ""}
                                onChange={handleInputChangeAdresse}
                            >
                                <option value="fr">FRANCE</option>
                            </FormSelect>
                        </FormGroup>

                        {/*Information MetaData */}
                        <EntHeaderTitle style={{ borderTop: "1.5px solid #809FB8", paddingTop: "1rem" }}>
                            <span style={{ display: "flex" }}>Informations Complémentaires
                                <IconDiv>
                                    <CTooltip title={"Ces informations sont utilisées dans la personnalisation des courriers"} className="tableActions__icon">
                                        <FontAwesomeIcon icon={faCircleInfo} style={{ marginLeft: "5px", marginRight: "2px" }} />
                                    </CTooltip>
                                </IconDiv>
                            </span>
                        </EntHeaderTitle>

                        <FormGroup>
                            <FormLabel htmlFor="codeApe">Code APE</FormLabel>
                            <FormInput
                                id="codeApe"
                                type="text"
                                name="codeApe"
                                // placeholder="Nom"
                                value={entity?.metadata?.codeApe || ""}
                                onChange={handleInputChangeMetaData}
                            />
                        </FormGroup>

                        <FormGroup>
                            <FormLabel htmlFor="fondDePage">Fond de page</FormLabel>
                            <FormInput
                                id="fondDePage"
                                type="text"
                                name="fondDePage"
                                // placeholder="Code"
                                value={entity?.metadata?.fondDePage || ""}
                                onChange={handleInputChangeMetaData}
                            />
                        </FormGroup>

                        <FormGroup>
                            <FormLabel htmlFor="formeJuridiqueSociete">Forme Juridique societé</FormLabel>
                            <FormInput
                                id="formeJuridiqueSociete"
                                type="text"
                                name="formeJuridiqueSociete"
                                // placeholder="Identifiant 1: N° Siret"
                                value={entity?.metadata?.formeJuridiqueSociete || ""}
                                onChange={handleInputChangeMetaData}
                            />
                        </FormGroup>

                        <FormGroup>
                            <FormLabel htmlFor="numeroTva">Numéro TVA</FormLabel>
                            <FormInput
                                id="numeroTva"
                                type="text"
                                name="numeroTva"
                                // placeholder="Identifiant 2: N° Siren"
                                value={entity?.metadata?.numeroTva || ""}
                                onChange={handleInputChangeMetaData}
                            />
                        </FormGroup>

                        <FormGroup>
                            <FormLabel htmlFor="rcs">RCS</FormLabel>
                            <FormInput
                                id="rcs"
                                type="text"
                                name="rcs"
                                // placeholder="Identifiant 3: N° TVA"
                                value={entity?.metadata?.rcs || ""}
                                onChange={handleInputChangeMetaData}
                            />
                        </FormGroup>

                        <FormGroup>
                            <FormLabel htmlFor="signataireCourrier">Signataire des courriers</FormLabel>
                            <FormInput
                                id="signataireCourrier"
                                type="text"
                                name="signataireCourrier"
                                // placeholder="Identifiant 3: N° TVA"
                                value={entity?.metadata?.signataireCourrier || ""}
                                onChange={handleInputChangeMetaData}
                            />
                        </FormGroup>

                        <FormGroup>
                            <FormLabel htmlFor="siret">SIRET</FormLabel>
                            <FormInput
                                id="siret"
                                type="text"
                                name="siret"
                                // placeholder="Identifiant 3: N° TVA"
                                value={entity?.metadata?.siret || ""}
                                onChange={handleInputChangeMetaData}
                            />
                        </FormGroup>

                        <FormGroup>
                            <FormLabel htmlFor="urlSiteWeb">Site web bailleur</FormLabel>
                            <FormInput
                                id="urlSiteWeb"
                                type="text"
                                name="urlSiteWeb"
                                // placeholder="Identifiant 3: N° TVA"
                                value={entity?.metadata?.urlSiteWeb || ""}
                                onChange={handleInputChangeMetaData}
                            />
                        </FormGroup>
                    </EIFormCol>
                </EIFormContainer>
                {userType == "ADMIN_YOUNOV" &&
                    <EIFormContainer>
                        <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                            <EntHeaderTitle style={{ borderTop: "1.5px solid #809FB8", paddingTop: "1rem" }}>
                                <span style={{ display: "flex" }}>Organismes de facturation</span>
                            </EntHeaderTitle>
                            <div style={{ maxWidth: '700px' }}>
                                <FormLabel htmlFor="countryCode">Organismes<div><FontAwesomeIcon icon={faCirclePlus} style={{ display: cannotBeModified ? "none" : "flex", marginLeft: "5px", marginRight: "2px", color: "#2174b980", fontSize: "1.25rem" }} onClick={e => addNewOrganisme(e)} /></div> </FormLabel>
                                <Table style={{ marginTop: "10px" }}>
                                    <THead>
                                        <tr style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                                            <TH style={{ width: "45%", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Libellé *</TH>
                                            <TH style={{ width: "45%", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Code *</TH>
                                            <TH style={{ width: "10%" }}></TH>
                                        </tr>
                                    </THead>
                                    {body}
                                </Table>
                            </div>
                        </div>
                    </EIFormContainer>
                }

                <EIFormContainer>
                    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                        <EntHeaderTitle style={{ borderTop: "1.5px solid #809FB8", paddingTop: "1rem" }}>
                            <span style={{ display: "flex" }}>Organisation des périmètres de gestion
                                <IconDiv>
                                    <CTooltip title={"Ces informations représentent l’organisation de votre entreprise concernant la gestion et le découpage des périmètres de rattachement des logements (Agences, Territoires, Unités de gestion, etc…"} className="tableActions__icon">
                                        <FontAwesomeIcon icon={faCircleInfo} style={{ marginLeft: "5px", marginRight: "2px" }} />
                                    </CTooltip>
                                </IconDiv>
                            </span>
                        </EntHeaderTitle>

                        <InfosHierarchie hierarchical={hierarchical} setHierarchical={setHierarchical} niveau={niveau} setNiveau={setNiveau} userType={userType} cannotBeModified={userType == "ADMIN_YOUNOV" ? false : true} />
                    </div>
                </EIFormContainer>
            </EntInfosContainer>

           
            <AssureursBailleurModal
                show={confirmationModalCodesAssureursShow}
                modalClosed={() => cancelModalAssureurs()}
                data={assureurs}
                uid={entity.id}
                getAssureurs={getAssureurs}
                cancel={() => cancelModalAssureurs()}
                title={"Visualisation référentiel assureur  "}

            />
        </>
    );
}

export default Infos;
